var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermissionKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "130.844 123.871 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.111106, 0, 0, 1.11117, 130.844284, 123.870987)",
    fill: "#2D6CE6",
    "data-bx-origin": "2.897 0.971"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.797,
    cy: 4.923,
    r: 1.125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.806 5.833c-.376-.956-1.064-2.336-2.212-3.479C14.45 1.215 13.085.546 12.142.186A2.826 2.826 0 0 0 9.143.82l-2.76 2.75a2.815 2.815 0 0 0-.588 3.12c.145.325.303.644.471.952l-6.06 6.062a.703.703 0 0 0-.206.497v3.095c0 .388.315.703.703.703h3.094a.703.703 0 0 0 .703-.703V16.03h1.266a.703.703 0 0 0 .703-.704v-1.266h1.265a.703.703 0 0 0 0-1.406H5.766a.703.703 0 0 0-.704.703v1.266H3.797a.703.703 0 0 0-.703.703v1.266H1.406v-2.1l6.235-6.236a.703.703 0 0 0 .104-.862 11.383 11.383 0 0 1-.665-1.276 1.4 1.4 0 0 1 .294-1.552l2.761-2.749A1.418 1.418 0 0 1 11.64 1.5c.816.313 1.993.887 2.962 1.852.975.97 1.569 2.165 1.895 2.996.203.519.08 1.108-.315 1.501l-2.795 2.782a1.416 1.416 0 0 1-1.547.302c-.44-.183-.866-.4-1.266-.646a.703.703 0 1 0-.735 1.199c.462.284.954.535 1.46.746 1.06.44 2.27.204 3.08-.604l2.795-2.782a2.803 2.803 0 0 0 .632-3.012z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionKey);
export default __webpack_public_path__ + "static/media/permission-key.8373814024963b986b03edba634477b1.svg";
export { ForwardRef as ReactComponent };